import { CategoryReference } from 'apprise-core/category'
import { Tag, TagReference } from 'apprise-core/tag'
import { useL } from 'apprise-frontend-core/intl/multilang'
import { useCategoryStore } from 'apprise-frontend-tags/category/store'
import { TagLabel } from 'apprise-frontend-tags/tag/label'
import { FieldInfo } from 'apprise-ui/field/model'
import { useReadonlyProps } from 'apprise-ui/readonly/readonly'
import { RecordBox, RecordBoxProps } from 'apprise-ui/recordbox/recordbox'
import { useTagStore } from './store'
import "./tagmapbox.scss"

export type TagmapBoxProps <T extends any = string> = Omit<RecordBoxProps<Record<TagReference,T>>, 'keys'> & {

    category: CategoryReference
    include?: (tag: Tag) => boolean

}
export const TagmapBox = <T extends any=string> (props: TagmapBoxProps<T>) => {

    const l = useL()

    const tagstore = useTagStore()
    const categories = useCategoryStore()

    const { category, include=()=>true, ...rest } = props

    const { children: values } = props
    
    const { readonly } = useReadonlyProps(rest)

    const cat = categories.safeLookupCategory(category)
    const keys = tagstore.allTagsOfCategory(category).filter(include).map(t=>t.id).filter(id=> readonly ? values?.[id] : id )

    const info: FieldInfo = {
        label: l(cat.name),
        msg: l(cat.properties.field.message ?? cat.description),
        help: l(cat.properties.field.help)
    }

    return <RecordBox info={info} keys={keys} renderKey={tag => <TagLabel bare noIcon tag={tag} />}  {...rest} />

}